import type { Question } from '../../types/game';
import clsx from 'clsx';

interface QuestionCardProps {
  question: Question;
  selectedAnswer?: string;
  onSelectAnswer: (answer: string) => void;
  showOptions: boolean;
  subjectColor?: string;
}

const labels = ['A', 'B', 'C', 'D'];

export const QuestionCard = ({ 
  question, 
  selectedAnswer,
  onSelectAnswer,
  showOptions,
  subjectColor = '#9d4edd'
}: QuestionCardProps) => {
  return (
    <div className="card p-6">
      <div className="flex items-center gap-4 mb-6">
        <span 
          className="px-4 py-2 rounded-xl text-white font-black uppercase tracking-wider border-2 border-white shadow-[2px_2px_0_white]"
          style={{ background: subjectColor }}
        >
          {question.subject_name}
        </span>
        <span className="text-warning font-bold text-lg">
          {question.points} {question.points === 1 ? 'punto' : 'puntos'}
        </span>
        <span className="text-xs text-muted ml-2">
          (Respuesta correcta: <span className="text-success font-bold">{question.answer}</span>)
        </span>
      </div>

      <h2 className="text-2xl font-bold mb-6">
        {question.question_text}
      </h2>

      <div className="grid grid-cols-2 gap-4">
        {question.options.slice(0, 4).map((option, index) => {
          const isCorrect = option === question.answer;
          const isSelected = selectedAnswer === option;

          return (
            <button
              key={option}
              onClick={() => onSelectAnswer(option)}
              disabled={!showOptions && !isCorrect}
              className={clsx(
                'flex items-center gap-4 p-4 rounded-xl border-2 font-black relative',
                'transition-all duration-100 ease-out',
                isCorrect && !isSelected
                  ? 'border-success bg-success text-black shadow-[4px_4px_0_currentColor]'
                  : isSelected
                    ? 'border-warning bg-warning text-black translate-x-1 translate-y-1 shadow-none'
                    : 'border-white bg-bg-deep shadow-[4px_4px_0_rgba(255,255,255,0.4)]',
                !showOptions && !isCorrect && 'cursor-not-allowed opacity-50 shadow-none translate-x-1 translate-y-1',
                showOptions && !isCorrect && 'hover:shadow-[4px_4px_0_white] hover:translate-x-0 cursor-pointer'
              )}
            >
              {isCorrect && (
                <span className="absolute top-2 right-2 text-success text-xs font-bold">
                  ✓
                </span>
              )}
              <span 
                className="w-12 h-12 rounded-xl border-2 border-current flex items-center justify-center font-black text-current"
                style={{ fontFamily: 'var(--font-family-mono)' }}
              >
                {labels[index]}
              </span>
              <span className="flex-1 text-left">{option}</span>
            </button>
          );
        })}
      </div>

      {showOptions && (
        <p className="text-xs text-muted mt-4 text-center">
          Haz clic en la opción que respondió el equipo
        </p>
      )}
    </div>
  );
};
